"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.INHERITED_TYPOGRAPHY = exports.DOCUMENT_ALREADY_READS_AS_PROPOSED_MESSAGE = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _OoxmlContent = _interopRequireDefault(require("@common/components/remedy/OoxmlContent"));
var _RedlineAuthorColorsContext = require("@common/components/remedy/RedlineAuthorColorsContext");
var _RedlinePreview = _interopRequireDefault(require("@common/components/remedy/RedlinePreview"));
var _revisionTitle = require("@common/components/remedy/revision-title");
var _redlineEngine = require("@common/utils/redline/redline-engine");
var _redlinePayload = require("@common/utils/redline/wire/redline-payload");
var _useLiveProposal = require("../../hooks/use-live-proposal");
var _cardLiveProposal = require("../chat/proposal-card/card-live-proposal");
var _proposalCardCollapsedContext = require("../chat/proposal-card/proposal-card-collapsed-context");
var _proposalEngineAccess = require("../../utils/proposal-engine-access");
var _proposedRevisions = require("@common/utils/redline/ooxml/proposed-revisions");
var _AppliedRedlineDocumentation = require("./AppliedRedlineDocumentation");
var _RevisionLegend = _interopRequireDefault(require("./RevisionLegend"));
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject;
/**
 * How long after the card mounts the Refind offer is held back. The seed read is
 * still in flight for the first seconds, and a paragraph it has not found yet is
 * not a lost paragraph. Measured on the one clock this code runs on; stored
 * timestamps are never consulted.
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var REFIND_OFFER_GRACE_MS = 5000;
var ProposedPreview = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  overflow-x: auto;\n"])));
var DOCUMENT_ALREADY_READS_AS_PROPOSED_MESSAGE = exports.DOCUMENT_ALREADY_READS_AS_PROPOSED_MESSAGE = "The document already reads as this redline proposes.";
var INHERITED_TYPOGRAPHY = exports.INHERITED_TYPOGRAPHY = {
  fontFamily: "inherit",
  fontSize: "inherit",
  lineHeight: "inherit",
  letterSpacing: "inherit"
};
var LiveProposalPanel = function LiveProposalPanel(_ref) {
  var _editLayer$textRedlin;
  var bookmarkNames = _ref.bookmarkNames,
    redlineOoxml = _ref.redlineOoxml,
    textRedline = _ref.textRedline,
    editLayer = _ref.editLayer,
    onProposalPackage = _ref.onProposalPackage,
    onDocumentAlreadyReadsAsProposed = _ref.onDocumentAlreadyReadsAsProposed,
    onCardBuildFailure = _ref.onCardBuildFailure,
    insertAfter = _ref.insertAfter,
    hidden = _ref.hidden,
    applied = _ref.applied,
    framed = _ref.framed;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    authorName = _useState2[0],
    setAuthorName = _useState2[1];
  /**
   * WHEN the org has the proposal engine off
   *   CONSEQUENCE
   *     The panel renders nothing, live or applied: a production card keeps the
   *     static preview above it and never shows the engine's legend or its
   *     applied-redline documentation. Starts false, so nothing flashes before
   *     the flag is known.
   */
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    proposalEngineEnabled = _useState4[0],
    setProposalEngineEnabled = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    refindOfferGraceElapsed = _useState6[0],
    setRefindOfferGraceElapsed = _useState6[1];
  (0, _react.useEffect)(function () {
    /** One timeout, cleared on unmount, so nothing keeps running once the card is gone. */
    var refindOfferGraceTimer = window.setTimeout(function () {
      return setRefindOfferGraceElapsed(true);
    }, REFIND_OFFER_GRACE_MS);
    return function () {
      return window.clearTimeout(refindOfferGraceTimer);
    };
  }, []);
  (0, _react.useEffect)(function () {
    var skipAuthorNameUpdateAfterUnmount = false;
    _proposalEngineAccess.ProposalEngineAccess.current().then(function (access) {
      /**
       * CASES
       *   - component still mounted, signed in, name present -> set that name
       *   - component still mounted, signed in, name missing -> set DIOPTRA_AUTHOR
       *   - component still mounted, signed out            -> set null
       *   - component unmounted                            -> skip the state update
       */
      if (!skipAuthorNameUpdateAfterUnmount) {
        var _access$authorName;
        var signedInAuthorName = (_access$authorName = access.authorName) !== null && _access$authorName !== void 0 ? _access$authorName : _redlineEngine.DIOPTRA_AUTHOR;
        var nextAuthorName = access.signedIn ? signedInAuthorName : null;
        /**
         * NULL
         *   undefined here means "bootstrap failed, leave authorName unchanged".
         *   The panel stays unavailable until access is established; no startup error is shown yet.
         */
        setAuthorName(nextAuthorName);
        setProposalEngineEnabled(access.enabled);
      }
    }).catch(function () {
      return undefined;
    });
    return function () {
      skipAuthorNameUpdateAfterUnmount = true;
    };
  }, []);
  var redline = (0, _react.useMemo)(function () {
    return (0, _cardLiveProposal.redlinePayloadOf)({
      redlineOoxml: redlineOoxml,
      textRedline: textRedline
    }, authorName);
  }, [redlineOoxml, textRedline, authorName]);
  var liveProposalCanRun = !hidden && !applied && !insertAfter && bookmarkNames.length > 0 && authorName !== null && proposalEngineEnabled && redline !== null;
  var liveProposalState = (0, _useLiveProposal.useLiveProposal)({
    bookmarkNames: bookmarkNames,
    redline: redline,
    editLayer: editLayer,
    enabled: liveProposalCanRun,
    hold: "recovering"
  });
  /** Only a proposal that was built can say the document already reads as it proposes; a seed still reading, or a failed one, has built nothing. */
  var proposalWasBuilt = liveProposalState.status === "proposed" || liveProposalState.status === "live";
  var documentAlreadyReadsAsProposed = proposalWasBuilt && liveProposalState.changeCount === 0;
  (0, _react.useEffect)(function () {
    onDocumentAlreadyReadsAsProposed === null || onDocumentAlreadyReadsAsProposed === void 0 || onDocumentAlreadyReadsAsProposed(documentAlreadyReadsAsProposed);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentAlreadyReadsAsProposed]);
  var cardBuildFailure = liveProposalState.status === "error" && liveProposalState.cardBuildFailed ? liveProposalState.error : null;
  (0, _react.useEffect)(function () {
    onCardBuildFailure === null || onCardBuildFailure === void 0 || onCardBuildFailure(cardBuildFailure);
    return function () {
      return onCardBuildFailure === null || onCardBuildFailure === void 0 ? void 0 : onCardBuildFailure(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardBuildFailure]);
  var textRedlineShown = (_editLayer$textRedlin = editLayer === null || editLayer === void 0 ? void 0 : editLayer.textRedline) !== null && _editLayer$textRedlin !== void 0 ? _editLayer$textRedlin : textRedline;
  var previewOoxml = (0, _react.useMemo)(function () {
    return (0, _cardLiveProposal.shownPreviewPackageOf)(liveProposalState.previewPackageOoxml, liveProposalState.stampedAt, textRedlineShown);
  }, [liveProposalState.previewPackageOoxml, liveProposalState.stampedAt, textRedlineShown]);
  var liveProposalRegistry = (0, _useLiveProposal.useLiveProposalRegistry)();
  var cardIsCollapsed = (0, _proposalCardCollapsedContext.useProposalCardIsCollapsed)();
  (0, _react.useEffect)(function () {
    onProposalPackage === null || onProposalPackage === void 0 || onProposalPackage(liveProposalState.proposalPackageOoxml, liveProposalState.stampedAt);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [liveProposalState.proposalPackageOoxml, liveProposalState.stampedAt]);
  var proposedCardMarkup = (0, _react.useMemo)(function () {
    return !framed && redlineOoxml !== null && redlineOoxml.length > 0 ? _proposedRevisions.ProposedRevisions.relabelNewestStamp(redlineOoxml) : null;
  }, [framed, redlineOoxml]);
  var cardMarkupPreview = proposedCardMarkup === null ? null : /*#__PURE__*/(0, _jsxRuntime.jsxs)(ProposedPreview, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_RevisionLegend.default, {
      ooxml: proposedCardMarkup,
      alwaysListedAuthors: []
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OoxmlContent.default, {
      ooxml: proposedCardMarkup,
      style: INHERITED_TYPOGRAPHY,
      getHtmlTitleProp: _revisionTitle.revisionTitleOf,
      drawMoveMarks: proposalEngineEnabled,
      drawReplacementGaps: proposalEngineEnabled
    })]
  });
  var textCardBestGuess = !framed && textRedlineShown !== null && ((0, _redlinePayload.carriesTableOperations)(textRedlineShown.tableChanges) || insertAfter) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppliedRedlineDocumentation.TextRedlineDocumentation, {
    textRedline: _objectSpread(_objectSpread({}, textRedlineShown), {}, {
      author: _proposedRevisions.PROPOSED_REVISIONS_AUTHOR
    }),
    framed: false
  }) : null;
  var cardOwnPreview = cardMarkupPreview !== null && cardMarkupPreview !== void 0 ? cardMarkupPreview : textCardBestGuess;
  var proposalPreviewOf = function proposalPreviewOf(packageOoxml, tableChangeLines, stampedAt) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(ProposedPreview, {
      className: framed ? "mt-2" : undefined,
      "data-sentry-element": "ProposedPreview",
      "data-sentry-component": "proposalPreviewOf",
      "data-sentry-source-file": "LiveProposalPanel.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_RevisionLegend.default, {
        ooxml: packageOoxml,
        alwaysListedAuthors: [],
        "data-sentry-element": "RevisionLegend",
        "data-sentry-source-file": "LiveProposalPanel.tsx"
      }), framed ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_RedlinePreview.default, {
        ooxml: packageOoxml,
        revisionTitle: _revisionTitle.revisionTitleOf,
        drawMoveMarks: true,
        drawReplacementGaps: true
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_OoxmlContent.default, {
        ooxml: packageOoxml,
        style: INHERITED_TYPOGRAPHY,
        getHtmlTitleProp: _revisionTitle.revisionTitleOf,
        drawMoveMarks: true,
        drawReplacementGaps: true,
        tableRowsExcerpt: cardIsCollapsed ? (0, _cardLiveProposal.collapsedTableRowsOptionsOf)({
          stampedAt: stampedAt
        }, {
          editLayer: editLayer
        }) : null
      }), framed && tableChangeLines.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
        className: "mt-1 list-none p-0 text-[11px] text-[#333]",
        children: tableChangeLines.map(function (line, index) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
            children: line
          }, "".concat(index, "-").concat(line));
        })
      })]
    });
  };
  if (hidden) return null;
  /**
   * WHEN the flag is off
   *   CONSEQUENCE
   *     Nothing renders, applied or not: the production card's own preview and
   *     applied state are all a flag-off user sees.
   */
  if (!proposalEngineEnabled) return cardOwnPreview;
  if (applied) {
    if (insertAfter || bookmarkNames.length === 0 || authorName === null || redline === null) return cardOwnPreview;
    var appliedLookRequest = {
      bookmarkNames: bookmarkNames,
      redline: redline,
      editLayer: editLayer
    };
    var appliedLook = textCardBestGuess === null ? liveProposalRegistry.appliedLookOf(appliedLookRequest) : liveProposalRegistry.lastLivePreview(appliedLookRequest);
    if (appliedLook === null) return cardOwnPreview;
    var appliedLookOoxml = (0, _cardLiveProposal.shownPreviewPackageOf)(appliedLook.previewPackageOoxml, appliedLook.stampedAt, textRedlineShown);
    return appliedLookOoxml ? proposalPreviewOf(appliedLookOoxml, appliedLook.tableChangeLines, appliedLook.stampedAt) : cardOwnPreview;
  }
  if (!liveProposalCanRun || liveProposalState.status === "off") return cardOwnPreview;
  /**
   * WHEN the paragraph could not be found inside the grace after mount
   *   CONSEQUENCE
   *     no error and no Refind yet: the panel falls through and keeps showing the
   *     proposed preview the state still holds, or nothing. The grace timer
   *     re-renders the panel when it elapses.
   */
  if (liveProposalState.status === "error" && refindOfferGraceElapsed) {
    /**
     * WHEN the error is anything but a lost bookmark (an engine refusal, a read that failed)
     *   CONSEQUENCE
     *     the sentence alone: Refind looks for the card's paragraph, and the paragraph is right there.
     */
    if (!liveProposalState.bookmarkLost) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "mt-2 text-[11px]",
        children: [cardOwnPreview, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "text-[#B45309]",
          children: liveProposalState.error
        })]
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "mt-2 text-[11px]",
      children: [cardOwnPreview, /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "text-[#B45309]",
        children: [liveProposalState.error, liveProposalState.serverAwaitsUserAction && " Refind with AI asks the server."]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: "mt-1 rounded border border-[#D4D3D0] bg-white px-2 py-0.5 text-[11px] text-primary disabled:opacity-50",
        disabled: liveProposalState.refinding,
        onClick: function onClick(clickEvent) {
          clickEvent.stopPropagation();
          void liveProposalState.refind();
        },
        children: liveProposalState.refinding ? "Asking the server…" : "Refind with AI"
      })]
    });
  }
  if (documentAlreadyReadsAsProposed) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "mt-2 text-[11px] italic text-[#666]",
      children: DOCUMENT_ALREADY_READS_AS_PROPOSED_MESSAGE
    });
  }
  if (textCardBestGuess !== null && liveProposalState.status !== "live") return textCardBestGuess;
  if (!previewOoxml) return cardOwnPreview;
  /**
   * One preview per redline: the package already holds the paragraphs and any
   * table change together (`PreviewPackage`); the caption lines name each row change.
   */
  return proposalPreviewOf(previewOoxml, liveProposalState.tableChangeLines, liveProposalState.stampedAt);
};
var LiveProposalPanelInsideRedlinePreview = function LiveProposalPanelInsideRedlinePreview(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RedlineAuthorColorsContext.InsideRedlinePreview, {
    "data-sentry-element": "InsideRedlinePreview",
    "data-sentry-component": "LiveProposalPanelInsideRedlinePreview",
    "data-sentry-source-file": "LiveProposalPanel.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(LiveProposalPanel, _objectSpread(_objectSpread({}, props), {}, {
      "data-sentry-element": "LiveProposalPanel",
      "data-sentry-source-file": "LiveProposalPanel.tsx"
    }))
  });
};
var _default = exports.default = LiveProposalPanelInsideRedlinePreview;